import axios from 'axios'

// Create axios instance
const api = axios.create({
  baseURL: '/',
  timeout: 30000,
  // Add redirect handling
  maxRedirects: 5,
  validateStatus: function (status) {
    return status >= 200 && status < 400 // Consider redirects as success
  }
})

// Add request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    
    // Add detailed logging
    console.log('Request interceptor:', {
      url: config.url,
      method: config.method,
      hasToken: !!token,
      headers: config.headers,
      currentPath: window.location.pathname
    })

    if (token) {
      // Ensure headers object exists
      config.headers = config.headers || {}
      // Always set Authorization header
      config.headers.Authorization = `Bearer ${token}`
      console.log('Token added to request:', `Bearer ${token.substring(0, 10)}...`)
    } else {
      console.warn('No token found for request:', config.url)
      
      // If no token and not a login request, reject
      if (!config.url.includes('auth/token')) {
        return Promise.reject(new Error('No authentication token'))
      }
    }

    return config
  },
  (error) => {
    console.error('Request interceptor error:', error)
    return Promise.reject(error)
  }
)

// Add response interceptor
api.interceptors.response.use(
  (response) => {
    // Handle redirects
    if (response.status >= 300 && response.status < 400) {
      console.log('Handling redirect:', response.headers.location)
      return api.request({
        method: response.config.method,
        url: response.headers.location,
        headers: response.config.headers
      })
    }

    console.log('Response success:', {
      url: response.config.url,
      status: response.status,
      hasData: !!response.data
    })
    return response
  },
  (error) => {
    console.error('Response Error:', {
      url: error.config?.url,
      status: error.response?.status,
      message: error.message,
      data: error.response?.data,
      headers: error.config?.headers
    })

    // Handle 401 errors globally
    if (error.response?.status === 401) {
      console.warn('Unauthorized request detected')
      
      // Clear token
      localStorage.removeItem('token')
      
      // Redirect to login using window.location
      // to avoid circular dependency with router
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login'
      }
    }

    return Promise.reject(error)
  }
)

// Add axios retry logic
api.interceptors.response.use(undefined, async (error) => {
  if (error.config && error.response && error.response.status === 401) {
    try {
      // Clear token and redirect to login
      localStorage.removeItem('token')
      return Promise.reject(error)
    } catch (refreshError) {
      return Promise.reject(refreshError)
    }
  }
  return Promise.reject(error)
})

export default api 